"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var PromoCodeTemplatesListCtl = /** @class */ (function (_super) {
    __extends(PromoCodeTemplatesListCtl, _super);
    function PromoCodeTemplatesListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.title; });
        _this.dk_brand_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_id; });
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        //public readonly dk_app_currency_id = UIUtils.IProp2Str((o: IPromoCodeTemplateListItem) => { o.app_currency_id });
        //public readonly dk_app_currency_title = UIUtils.IProp2Str((o: IPromoCodeTemplateListItem) => { o.app_currency_title });
        _this.dk_prefix = UIUtils_1.UIUtils.IProp2Str(function (o) { o.prefix; });
        _this.dk_is_can_expire = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_can_expire; });
        //public readonly dk_expire_date = UIUtils.IProp2Str((o: IPromoCodeTemplateListItem) => { o.expire_date });
        _this.dk_expire_year = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_year; });
        _this.dk_expire_month = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_month; });
        _this.dk_expire_day = UIUtils_1.UIUtils.IProp2Str(function (o) { o.expire_day; });
        _this.dk_is_disposable_codes = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_disposable_codes; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_locked; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_template_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_type_code; });
        _this.dk_template_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocode_template_type_title; });
        _this.dk_is_req_bonus_level = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_req_bonus_level; });
        _this.dk_bonus_level_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_level_id; });
        _this.dk_bonus_level_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_level_title; });
        _this.dk_cms_image_url = UIUtils_1.UIUtils.IProp2Str(function (o) { o.cms_image_url; });
        _this.dk_is_all_country = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_all_country; });
        _this.dk_promocodes_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promocodes_count; });
        _this.dk_bonuses_count = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonuses_count; });
        _this.dk_is_can_used_multiple_times = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_can_used_multiple_times; });
        _this.dk_promo_reactivation_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_reactivation_type_code; });
        _this.dk_promo_reactivation_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.promo_reactivation_type_title; });
        _this.dk_is_allow_by_day_of_week_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_by_day_of_week_only; });
        _this.dk_is_allow_on_monday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_monday; });
        _this.dk_is_allow_on_tuesday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_tuesday; });
        _this.dk_is_allow_on_wednesday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_wednesday; });
        _this.dk_is_allow_on_thursday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_thursday; });
        _this.dk_is_allow_on_friday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_friday; });
        _this.dk_is_allow_on_saturday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_saturday; });
        _this.dk_is_allow_on_sunday = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_on_sunday; });
        _this.dk_is_allow_by_day_number_only = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_allow_by_day_number_only; });
        _this.dk_day_numbers_separated_string = UIUtils_1.UIUtils.IProp2Str(function (o) { o.day_numbers_separated_string; });
        _this.dk_is_restrict_by_deposit_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_restrict_by_deposit_age; });
        _this.dk_deposit_age_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_code; });
        _this.dk_deposit_age_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.deposit_age_type_title; });
        _this.dk_is_restrict_by_deposit_total_amount_during_deposit_age = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_restrict_by_deposit_total_amount_during_deposit_age; });
        _this.dk_is_restrict_multi_activation_promocode_tpl_by_one_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_restrict_multi_activation_promocode_tpl_by_one_player; });
        _this.dk_is_restrict_to_activate_promo_owned_by_different_partner = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_restrict_to_activate_promo_owned_by_different_partner; });
        _this._errDialog = errDialog;
        return _this;
    }
    PromoCodeTemplatesListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            //currency_filter: [],
            promo_type_filter: [],
            total: 0,
            cdn_baseurl: ""
        };
    };
    PromoCodeTemplatesListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "promo code template with id [" + id + "] not found !";
    };
    //public getCurrencyFilter(): IPromoTPLFilterInfo[] {
    //    return this.DATA.currency_filter;
    //}
    PromoCodeTemplatesListCtl.prototype.getPromoCodeTypeFilter = function () {
        return this.DATA.promo_type_filter;
    };
    PromoCodeTemplatesListCtl.prototype.LoadData = function (AllBrands, BrandIdList, onDone) {
        var _this = this;
        webAApi_1.ListPromoCodeTemplatesByBrandIdGet.exec({
            all_brands: AllBrands,
            brand_id_list: BrandIdList
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            _this.DATA.cdn_baseurl = resp.cdn_baseurl;
            //
            //this.DATA.currency_filter = [];
            //let currency_filter_map = new Map<string, string>();
            //
            _this.DATA.promo_type_filter = [];
            var promo_type_filter_map = new Map();
            //
            for (var i = 0; i < resp.list.length; i++) {
                //if (!currency_filter_map.get(resp.list[i].app_currency_title)) {
                //    this.DATA.currency_filter.push({ text: resp.list[i].app_currency_title, value: resp.list[i].app_currency_title });
                //    currency_filter_map.set(resp.list[i].app_currency_title, resp.list[i].app_currency_title);
                //}
                if (!promo_type_filter_map.get(resp.list[i].promocode_template_type_title)) {
                    _this.DATA.promo_type_filter.push({ text: resp.list[i].promocode_template_type_title, value: resp.list[i].promocode_template_type_title });
                    promo_type_filter_map.set(resp.list[i].promocode_template_type_title, resp.list[i].promocode_template_type_title);
                }
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_id: resp.list[i].brand_id,
                    brand_title: resp.list[i].brand_title,
                    //app_currency_id: resp.list[i].app_currency_id,
                    //app_currency_title: resp.list[i].app_currency_title,
                    // expire_date: moment(resp.list[i].expire_date_uts_ms).utc(false),
                    expire_day: resp.list[i].expire_day,
                    expire_month: resp.list[i].expire_month,
                    expire_year: resp.list[i].expire_year,
                    is_can_expire: resp.list[i].is_can_expire,
                    is_locked: resp.list[i].is_locked,
                    title: resp.list[i].title,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                    is_disposable_codes: resp.list[i].is_disposable_codes,
                    //is_req_min_totalbet: resp.list[i].is_req_min_totalbet,
                    //min_totalbet_amount: resp.list[i].min_totalbet_amount,
                    prefix: resp.list[i].prefix,
                    promocode_template_type_code: resp.list[i].promocode_template_type_code,
                    promocode_template_type_title: resp.list[i].promocode_template_type_title,
                    //is_use_affilate: resp.list[i].is_use_affilate,
                    //affilate_id: resp.list[i].affilate_id,
                    //affilate_title: resp.list[i].affilate_title,
                    //partner_id: resp.list[i].partner_id,
                    //partner_login: resp.list[i].partner_login,
                    //partner_offer_id: resp.list[i].partner_offer_id,
                    //partner_offer_title: resp.list[i].partner_offer_title,
                    //is_use_tracker: resp.list[i].is_use_tracker,
                    //partner_tracker_id: resp.list[i].partner_tracker_id,
                    //partner_tracker_title: resp.list[i].partner_tracker_title,
                    is_req_bonus_level: resp.list[i].is_req_bonus_level,
                    bonus_level_id: resp.list[i].bonus_level_id,
                    bonus_level_title: resp.list[i].bonus_level_title,
                    cms_image_url: resp.list[i].cms_image_url,
                    is_all_country: resp.list[i].is_all_country,
                    promocodes_count: resp.list[i].promocodes_count,
                    bonuses_count: resp.list[i].bonuses_count,
                    is_can_used_multiple_times: resp.list[i].is_can_used_multiple_times,
                    promo_reactivation_type_code: resp.list[i].promo_reactivation_type_code,
                    promo_reactivation_type_title: resp.list[i].promo_reactivation_type_title,
                    is_allow_by_day_of_week_only: resp.list[i].is_allow_by_day_of_week_only,
                    is_allow_on_monday: resp.list[i].is_allow_on_monday,
                    is_allow_on_tuesday: resp.list[i].is_allow_on_tuesday,
                    is_allow_on_wednesday: resp.list[i].is_allow_on_wednesday,
                    is_allow_on_thursday: resp.list[i].is_allow_on_thursday,
                    is_allow_on_friday: resp.list[i].is_allow_on_friday,
                    is_allow_on_saturday: resp.list[i].is_allow_on_saturday,
                    is_allow_on_sunday: resp.list[i].is_allow_on_sunday,
                    is_allow_by_day_number_only: resp.list[i].is_allow_by_day_number_only,
                    day_numbers_separated_string: resp.list[i].day_numbers_separated_string,
                    is_restrict_by_deposit_age: resp.list[i].is_restrict_by_deposit_age,
                    deposit_age_type_code: resp.list[i].deposit_age_type_code,
                    deposit_age_type_title: resp.list[i].deposit_age_type_title,
                    is_restrict_by_deposit_total_amount_during_deposit_age: resp.list[i].is_restrict_by_deposit_total_amount_during_deposit_age,
                    is_restrict_multi_activation_promocode_tpl_by_one_player: resp.list[i].is_restrict_multi_activation_promocode_tpl_by_one_player,
                    is_restrict_to_activate_promo_owned_by_different_partner: resp.list[i].is_restrict_to_activate_promo_owned_by_different_partner
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplatesListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddPromoCodeTemplate.exec({
            data: {
                title: data.title,
                brand_id: data.brand_id,
                //app_currency_id: data.app_currency_id,
                expire_day: data.expire_day,
                expire_month: data.expire_month,
                expire_year: data.expire_year,
                is_can_expire: data.is_can_expire,
                is_locked: data.is_locked,
                description: data.description,
                is_disposable_codes: data.is_disposable_codes,
                //is_req_min_totalbet: data.is_req_min_totalbet,
                //min_totlabet_amount: data.min_totlabet_amount,
                prefix: data.prefix,
                promocode_template_type_code: data.promocode_template_type_code,
                //is_use_affilate: data.is_use_affilate,
                //affilate_id: data.affilate_id,
                //partner_id: data.partner_id,
                //partner_offer_id: data.partner_offer_id,
                //is_use_tracker: data.is_use_tracker,
                //partner_tracker_id: data.partner_tracker_id,
                is_req_bonus_level: data.is_req_bonus_level,
                bonus_level_id: data.bonus_level_id,
                cms_image_url: data.cms_image_url,
                is_all_country: data.is_all_country,
                is_can_used_multiple_times: data.is_can_used_multiple_times,
                is_allow_by_day_of_week_only: data.is_allow_by_day_of_week_only,
                is_allow_on_monday: data.is_allow_on_monday,
                is_allow_on_tuesday: data.is_allow_on_tuesday,
                is_allow_on_wednesday: data.is_allow_on_wednesday,
                is_allow_on_thursday: data.is_allow_on_thursday,
                is_allow_on_friday: data.is_allow_on_friday,
                is_allow_on_saturday: data.is_allow_on_saturday,
                is_allow_on_sunday: data.is_allow_on_sunday,
                promo_reactivation_type_code: data.promo_reactivation_type_code,
                is_allow_by_day_number_only: data.is_allow_by_day_number_only,
                day_numbers_separated_string: data.day_numbers_separated_string,
                is_restrict_by_deposit_age: data.is_restrict_by_deposit_age,
                deposit_age_type_code: data.deposit_age_type_code,
                is_restrict_by_deposit_total_amount_during_deposit_age: data.is_restrict_by_deposit_total_amount_during_deposit_age,
                is_restrict_multi_activation_promocode_tpl_by_one_player: data.is_restrict_multi_activation_promocode_tpl_by_one_player,
                is_restrict_to_activate_promo_owned_by_different_partner: data.is_restrict_to_activate_promo_owned_by_different_partner
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                date_changed: moment(resp.date_changed_uts_ms).utc(false),
                date_added: moment(resp.date_added_uts_ms).utc(false),
                //app_currency_id: data.app_currency_id,
                //app_currency_title: resp.app_currency_title,
                // expire_date: moment(resp.date_expired_uts_ms).utc(false),
                expire_day: data.expire_day,
                expire_month: data.expire_month,
                expire_year: data.expire_year,
                is_can_expire: data.is_can_expire,
                is_locked: data.is_locked,
                title: data.title,
                brand_id: data.brand_id,
                brand_title: resp.brand_title,
                description: data.description,
                is_disposable_codes: data.is_disposable_codes,
                //is_req_min_totalbet: data.is_req_min_totalbet,
                //min_totalbet_amount: data.min_totlabet_amount,
                prefix: data.prefix,
                promocode_template_type_code: data.promocode_template_type_code,
                promocode_template_type_title: resp.promocode_template_type_title,
                //is_use_affilate: data.is_use_affilate,
                //affilate_id: data.affilate_id,
                //affilate_title: resp.affilate_title,
                //partner_id: data.partner_id,
                //partner_login: resp.partner_login,
                //partner_offer_id: data.partner_offer_id,
                //partner_offer_title: resp.partner_offer_title,
                //is_use_tracker: data.is_use_tracker,
                //partner_tracker_id: data.partner_tracker_id,
                //partner_tracker_title: resp.partner_tracker_title,
                is_req_bonus_level: data.is_req_bonus_level,
                bonus_level_id: data.bonus_level_id,
                bonus_level_title: resp.bonus_level_title,
                cms_image_url: data.cms_image_url,
                is_all_country: data.is_all_country,
                promocodes_count: 0,
                bonuses_count: 0,
                is_can_used_multiple_times: data.is_can_used_multiple_times,
                is_allow_by_day_of_week_only: data.is_allow_by_day_of_week_only,
                is_allow_on_monday: data.is_allow_on_monday,
                is_allow_on_tuesday: data.is_allow_on_tuesday,
                is_allow_on_wednesday: data.is_allow_on_wednesday,
                is_allow_on_thursday: data.is_allow_on_thursday,
                is_allow_on_friday: data.is_allow_on_friday,
                is_allow_on_saturday: data.is_allow_on_saturday,
                is_allow_on_sunday: data.is_allow_on_sunday,
                promo_reactivation_type_code: data.promo_reactivation_type_code,
                promo_reactivation_type_title: resp.promo_reactivation_type_title,
                is_allow_by_day_number_only: data.is_allow_by_day_number_only,
                day_numbers_separated_string: data.day_numbers_separated_string,
                is_restrict_by_deposit_age: data.is_restrict_by_deposit_age,
                deposit_age_type_code: data.deposit_age_type_code,
                deposit_age_type_title: resp.deposit_age_type_title,
                is_restrict_by_deposit_total_amount_during_deposit_age: data.is_restrict_by_deposit_total_amount_during_deposit_age,
                is_restrict_multi_activation_promocode_tpl_by_one_player: data.is_restrict_multi_activation_promocode_tpl_by_one_player,
                is_restrict_to_activate_promo_owned_by_different_partner: data.is_restrict_to_activate_promo_owned_by_different_partner
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    PromoCodeTemplatesListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditPromoCodeTemplate.exec({
                data: {
                    promocode_template_id: data.key,
                    title: data.title,
                    expire_day: data.expire_day,
                    expire_month: data.expire_month,
                    expire_year: data.expire_year,
                    is_can_expire: data.is_can_expire,
                    description: data.description,
                    is_disposable_codes: data.is_disposable_codes,
                    is_locked: data.is_locked,
                    prefix: data.prefix,
                    //is_req_min_totalbet: data.is_req_min_totalbet,
                    // min_totalbet_amount: data.min_totalbet_amount,
                    //is_use_affilate: data.is_use_affilate,
                    //affilate_id: data.affilate_id,
                    //partner_id: data.partner_id,
                    //partner_offer_id: data.partner_offer_id,
                    //is_use_tracker: data.is_use_tracker,
                    //partner_tracker_id: data.partner_tracker_id,
                    is_req_bonus_level: data.is_req_bonus_level,
                    bonus_level_id: data.bonus_level_id,
                    cms_image_url: data.cms_image_url,
                    is_all_country: data.is_all_country,
                    is_can_used_multiple_times: data.is_can_used_multiple_times,
                    is_allow_by_day_of_week_only: data.is_allow_by_day_of_week_only,
                    is_allow_on_monday: data.is_allow_on_monday,
                    is_allow_on_tuesday: data.is_allow_on_tuesday,
                    is_allow_on_wednesday: data.is_allow_on_wednesday,
                    is_allow_on_thursday: data.is_allow_on_thursday,
                    is_allow_on_friday: data.is_allow_on_friday,
                    is_allow_on_saturday: data.is_allow_on_saturday,
                    is_allow_on_sunday: data.is_allow_on_sunday,
                    promo_reactivation_type_code: data.promo_reactivation_type_code,
                    is_allow_by_day_number_only: data.is_allow_by_day_number_only,
                    day_numbers_separated_string: data.day_numbers_separated_string,
                    is_restrict_by_deposit_age: data.is_restrict_by_deposit_age,
                    deposit_age_type_code: data.deposit_age_type_code,
                    is_restrict_by_deposit_total_amount_during_deposit_age: data.is_restrict_by_deposit_total_amount_during_deposit_age,
                    is_restrict_multi_activation_promocode_tpl_by_one_player: data.is_restrict_multi_activation_promocode_tpl_by_one_player,
                    is_restrict_to_activate_promo_owned_by_different_partner: data.is_restrict_to_activate_promo_owned_by_different_partner
                }
            }, function (resp) {
                _tmp.title = data.title;
                _tmp.title = data.title;
                _tmp.expire_day = data.expire_day;
                _tmp.expire_month = data.expire_month;
                _tmp.expire_year = data.expire_year;
                _tmp.is_can_expire = data.is_can_expire;
                _tmp.is_disposable_codes = data.is_disposable_codes;
                _tmp.is_locked = data.is_locked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.is_req_bonus_level = data.is_req_bonus_level;
                _tmp.bonus_level_id = data.bonus_level_id;
                _tmp.bonus_level_title = resp.bonus_level_title;
                _tmp.cms_image_url = data.cms_image_url;
                _tmp.is_all_country = data.is_all_country;
                _tmp.is_can_used_multiple_times = data.is_can_used_multiple_times;
                _tmp.promo_reactivation_type_code = data.promo_reactivation_type_code;
                _tmp.promo_reactivation_type_title = resp.promo_reactivation_type_title;
                _tmp.is_allow_by_day_number_only = data.is_allow_by_day_number_only;
                _tmp.day_numbers_separated_string = data.day_numbers_separated_string;
                _tmp.is_restrict_by_deposit_age = data.is_restrict_by_deposit_age;
                _tmp.deposit_age_type_code = data.deposit_age_type_code;
                _tmp.deposit_age_type_title = resp.deposit_age_type_title;
                _tmp.is_restrict_by_deposit_total_amount_during_deposit_age = data.is_restrict_by_deposit_total_amount_during_deposit_age;
                //_tmp.is_req_min_totalbet = data.is_req_min_totalbet;
                //_tmp.min_totalbet_amount = data.min_totalbet_amount;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplatesListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    PromoCodeTemplatesListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeletePromoCodeTemplate.exec({ data: { promocode_template_id: key } }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplatesListCtl.prototype.SetIsLocked = function (key, IsLocked, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoSetPromoCodeTemplateIsLocked.exec({ data: { promocode_template_id: key, locked: IsLocked } }, function (resp) {
                _tmp.is_locked = IsLocked;
                _tmp.date_changed = moment(resp.date_changed_uts_ms).utc(false);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    PromoCodeTemplatesListCtl.prototype.DoClonePromoCodeTemplate = function (key, Prefix, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoClonePromoCodeTemplate.exec({ data: { promocode_template_id: key, prefix: Prefix } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return PromoCodeTemplatesListCtl;
}(BaseController_1.BaseController));
exports.PromoCodeTemplatesListCtl = PromoCodeTemplatesListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_promocodes/ctl/PromoCodeTemplatesListCtl.ts
// module id = 878
// module chunks = 0